import { render, staticRenderFns } from "./FinanceItem.vue?vue&type=template&id=d1f24a90&"
import script from "./FinanceItem.vue?vue&type=script&lang=js&"
export * from "./FinanceItem.vue?vue&type=script&lang=js&"
import style0 from "./FinanceItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports